import { FC, useEffect, useState } from 'react';
import { useContextSelector } from 'use-context-selector';

import { getUserProfileBusiness } from '@/core/apis/orders-apis';
import { authSelector } from '@/core/store/global/app-states';
import { AppContext } from '@/core/store/global/AppProvider';
import { Button } from '@/ux/components/shadcn/ui/button';
import { Input } from '@/ux/components/shadcn/ui/input';

type BusinessDetailsCaptureProps = {
  onNext: any;
  onBack: any;
  setBusinessData: any;
  businessData: any;
  stage: number;
};
const BusinessDetailsCapture: FC<BusinessDetailsCaptureProps> = ({
  onNext,
  onBack,
  setBusinessData,
  businessData,
  stage,
}) => {
  const authentication = useContextSelector(AppContext, authSelector);
  const [businessDetails, setBusinessDetails] = useState<any>({
    name: businessData?.name || '',
  });
  const [savedBusinesses, setSavedBusinesses] = useState<any>([]);

  useEffect(() => {
    if (authentication?.loggedIn) {
      fetchBusinessList();
    }
  }, [authentication]);

  const fetchBusinessList = async () => {
    getUserProfileBusiness().then((res: any) => {
      setSavedBusinesses(res);
    });
  };

  const handleChange = (field: any, value: any) => {
    setBusinessDetails({ ...businessDetails, [field]: value });
  };

  const handleSubmit = () => {
    setBusinessData(businessDetails);
    onNext();
  };

  const onSelectAddress: any = (e: any) => {
    const business = savedBusinesses?.find((address: any) => address?.guid == e.target.value);

    if (business) {
      const { name } = business;
      setBusinessDetails({ _id: business?.guid, name: business?.name });
    } else {
      setBusinessDetails({ name: '' });
    }
  };

  return (
    <div className="flex gap-2 flex-col h-full">
      <div className="grow overflow-y-auto">
        <div className="space-y-4 p-1">
          {authentication?.loggedIn && (
            <select
              className="w-full border-gray-200 rounded-md focus:border-gray-200 focus:ring-gray-200"
              onChange={onSelectAddress}
            >
              <option>Select saved or enter new Business...</option>
              {savedBusinesses?.map((business: any) => {
                return (
                  <option value={business?.guid} key={business?.guid}>
                    {business?.name}
                  </option>
                );
              })}
            </select>
          )}
          <div className="rounded-md space-y-2">
            <Input
              placeholder="Business Name"
              value={businessDetails.name}
              onChange={(e) => handleChange('name', e.target.value)}
            />
          </div>
        </div>
      </div>
      <div className={`flex p-2 ${stage > 0 ? 'justify-between' : 'justify-end'}`}>
        {stage > 0 && (
          <Button onClick={onBack} className="bg-black text-white">
            Back
          </Button>
        )}
        <Button onClick={handleSubmit} className="bg-black text-white">
          Next
        </Button>
      </div>
    </div>
  );
};

export default BusinessDetailsCapture;
